module.exports = __webpack_public_path__ + "img/GSTSystemRender.6ca2c465.png";